import firebase from 'firebase/compat/app'
import 'firebase/compat/messaging'

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey:            process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain:        process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId:         process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket:     process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId:             process.env.VUE_APP_FIREBASE_APP_ID,
  })
}

const messaging = firebase.messaging()

export async function requestFCMToken() {
  try {
    return await messaging.getToken({ vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY })
  } catch (e) {
    console.error('FCM token error:', e)
    return null
  }
}

export function onFCMMessage(callback) {
  return messaging.onMessage(callback)
}
